import { AiOutlineCheck } from 'react-icons/ai';
import { FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { type User } from '../../../common/types';
import { UserRoleLabel } from '../../../common/constants';

interface IProps {
  item: User;
  actions: any[];
}

const ListUserItem: React.FC<IProps> = ({ item, actions }) => {
  return (
    <tr className="odd:bg-white even:bg-gray-50" key={item.id}>
      <td className="p-2 pl-8 text-sm text-gray-700 whitespace-nowrap">
        <div className="flex flex-col">
          <span>{item.fullname}</span>
        </div>
      </td>
      <td className="p-2 text-sm text-gray-700 whitespace-nowrap">{item.email}</td>
      <td className="p-2 text-sm text-gray-700 whitespace-nowrap">
        {item?.role != null ? UserRoleLabel[item.role] : ''}
      </td>
      <td className="p-2 text-sm text-gray-700">
        {item.isRootUser && <AiOutlineCheck size={24} color="green" />}
        {!item.isRootUser && <FaTimes size={24} color="red" />}
      </td>
      <td className="p-2 text-sm text-gray-700">
        {item.isApproved && <AiOutlineCheck size={24} color="green" />}
        {!item.isApproved && <FaTimes size={24} color="red" />}
      </td>
      <td className="p-2 text-sm text-gray-700">
        {item.isActive && <AiOutlineCheck size={24} color="green" />}
        {!item.isActive && <FaTimes size={24} color="red" />}
      </td>
      <td className="w-24 p-2 pr-8 text-sm text-gray-700 whitespace-nowrap">
        <div className="flex flex-row justify-items-center items-center space-x-2">
          {actions.map((action, index) => {
            if (action.type === 'link') {
              return (
                <Link to={action.link} key={index}>
                  <span className="px-1 h-full">{action.icon}</span>
                </Link>
              );
            } else if (action.type === 'component') {
              return <div key={index}>{action.icon}</div>;
            } else {
              return (
                <button key={index} onClick={action.handler} className="text-gray-50 text-sm text-center rounded-md">
                  <span className="px-1 h-full">{action.icon}</span>
                </button>
              );
            }
          })}
        </div>
      </td>
    </tr>
  );
};

export default ListUserItem;
